import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import type {
  BulkUpdateOtBehaviourVariables,
  BulkUpdateOtBehaviourResponse,
} from '../types';

const bulkUpdateOtBehaviourMutation = gql`
  mutation OvertimeBulkUpdateOtBehaviour($input: OvertimeBulkUpdateOtBehaviourInput!) {
    overtimeBulkUpdateOtBehaviour(input: $input) {
      code
      success
      message
    }
  }
`;

const bulkUpdateOtBehaviour = (variables: BulkUpdateOtBehaviourVariables) => {
  return graphQLApi<
    { overtimeBulkUpdateOtBehaviour: BulkUpdateOtBehaviourResponse },
    BulkUpdateOtBehaviourVariables
  >({
    query: bulkUpdateOtBehaviourMutation,
    queryVariables: variables,
  });
};

export default bulkUpdateOtBehaviour;
